/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercises: NonNullable<unknown>, sets: NonNullable<unknown> }} Native_Release_Widget_Today_DoseInputs */

const en_us2_native_release_widget_today_dose = /** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercises: ${i?.exercises} · Sets: ${i?.sets}`)
};

const pt_br2_native_release_widget_today_dose = /** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercícios: ${i?.exercises} · Séries: ${i?.sets}`)
};

const pt_pt2_native_release_widget_today_dose = /** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercícios: ${i?.exercises} · Séries: ${i?.sets}`)
};

/** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */
const es_419_native_release_widget_today_dose = en_us2_native_release_widget_today_dose;

/** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */
const fr_fr2_native_release_widget_today_dose = en_us2_native_release_widget_today_dose;

/** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */
const de_de2_native_release_widget_today_dose = en_us2_native_release_widget_today_dose;

/** @type {(inputs: Native_Release_Widget_Today_DoseInputs) => LocalizedString} */
const it_it2_native_release_widget_today_dose = en_us2_native_release_widget_today_dose;

/**
* | output |
* | --- |
* | "Exercises: {exercises} · Sets: {sets}" |
*
* @param {Native_Release_Widget_Today_DoseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_today_dose = /** @type {((inputs: Native_Release_Widget_Today_DoseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Today_DoseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_today_dose(inputs)
	if (locale === "es-419") return es_419_native_release_widget_today_dose(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_today_dose(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_today_dose(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_today_dose(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_today_dose(inputs)
	return en_us2_native_release_widget_today_dose(inputs)
});
export { native_release_widget_today_dose as "native-release.widget_today_dose" }